import { useEffect, useRef, useState } from "react";
import { getPostal } from "../../../../../common-deprecated/utils/postalUtils";
import { POSTAL_CHANNEL_FQS, POSTAL_TOPIC_FQS_QUOTE_SET } from "../../../../../common-deprecated/constants";
import type { BuildAndBuyDispatchType } from "../../redux/store";
import { updateQuoteConfig } from "../../redux/actions/FinanceInsuranceActions";
import { useDebouncedEffect } from "../../../../../common-deprecated/hooks";
import type { UpdateQuoteConfigType } from "../../../../../common-deprecated/types/CommonTypes";
import { useDispatch } from "../../../../../shared-logic/redux/store";

type UseFinanceCalculatorReturnType = {
    updateQuote: (data: UpdateQuoteConfigType | undefined) => void;
};

const useFinanceCalculator = (loadExternalPriceFunction: boolean): UseFinanceCalculatorReturnType => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const postalSubscription = useRef<ReturnType<Postal["subscribe"]>>();
    const [financeQuote, setFinanceQuote] = useState<string | undefined>();
    const [financeProduct, setFinanceProduct] = useState<string | undefined>();

    useEffect(() => {
        postalSubscription.current = getPostal().subscribe({
            channel: POSTAL_CHANNEL_FQS,
            topic: POSTAL_TOPIC_FQS_QUOTE_SET,
            callback: (data: { finance: string; productType: string }) => {
                if (data.finance) setFinanceQuote(data.finance);
                if (data.productType) setFinanceProduct(data.productType);
            },
        });

        return () => {
            if (postalSubscription.current) {
                getPostal().unsubscribe(postalSubscription.current);
            }
        };
    }, []);

    // As these values can change on multiple occasions, we use a debouncedEffect so the actual quoteConfig only gets set once.
    useDebouncedEffect(
        () => {
            dispatch(
                updateQuoteConfig({ finance: financeQuote, productName: financeProduct }, loadExternalPriceFunction),
            );
        },
        100,
        [financeQuote, financeProduct],
    );

    const updateQuote = (data: UpdateQuoteConfigType | undefined): void => {
        setFinanceQuote(data?.finance ?? undefined);
    };

    return { updateQuote };
};

export default useFinanceCalculator;
